import {mapGetters} from 'vuex';
export default {
  data() {
    return {

    }
  },
    computed: {
        ...mapGetters([
            'sidebar',
            'userName',
            'avatar',
            'groupType',
            'btnCode'
        ])
    },
  methods: {
      getUserPermission() {
          if (!this.userName){
              // this.$store.dispatch('GetInfo',{}).then(res => {
              //     let roleList = res.roleList
              //     this.$store.dispatch('setRouter', roleList).then(() => { // 生成可访问的路由表
              //         let addRouters = this.$store.getters.addRouters
              //         localStorage.setItem('addRouters', JSON.stringify(addRouters));
              //         this.$router.addRoutes(addRouters) // 动态添加可访问路由表
              //         this.loading = false;
              //     })
              //     return;
              //
              // }).catch(err => {
              // });
          }
      }
  },
  created(){
      console.log('mixin user')
      this.getUserPermission()
  },
}



// WEBPACK FOOTER //
// ./src/mixin/user.js